import { z } from "zod/v4";
import { entryListRowSchema, tournamentEntryRowSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export interface EntriesParams {
	tournament?: string;
	athlete?: string;
	status?: string;
	limit?: number;
}

export const entries = {
	list: (params: EntriesParams = {}) => {
		const query = new URLSearchParams();
		if (params.tournament) query.set("tournament", params.tournament);
		if (params.athlete) query.set("athlete", params.athlete);
		if (params.status) query.set("status", params.status);
		if (params.limit) query.set("limit", String(params.limit));
		const qs = query.toString();
		return fetchApi(`/tournament-entries${qs ? `?${qs}` : ""}`, z.array(tournamentEntryRowSchema));
	},
	entryLists: (tournamentId: string) =>
		fetchApi(
			`/entry-lists?tournament=${encodeURIComponent(tournamentId)}`,
			z.array(entryListRowSchema),
		),
};
